import React from 'react';
import { Helmet } from 'react-helmet';

const fleetPackages = [
  {
    id: 1,
    image: '/images/keyword/2.jpg',
    location: 'Pune to Shirdi Cab Booking',
    title: 'Experience a peaceful and reliable journey with Mauli Cabs. Our Pune to Shirdi Cab Booking service ensures a smooth ride with well-maintained vehicles and professional drivers—perfect for your temple visit or weekend getaway.',
    link: '/Pune-to-Shirdi-Cab-Booking',
    duration: '6 - Days',
    oldPrice: '$800',
    newPrice: '$700',
  },
  {
    id: 2,
    image: '/images/keyword/3.jpg',
    location: 'Pune to Mahabaleshwar Cab',
    title: 'Embark on a scenic journey with Mauli Cabs. Our Pune to Mahabaleshwar Cab Service offers a comfortable and hassle-free ride, ensuring you enjoy the lush landscapes and serene beauty of the Western Ghats.',
    link: '/Pune-to-Mahabaleshwar-Cab',
    duration: '3 - Days',
    oldPrice: '$800',
    newPrice: '$400',
  },
  {
    id: 3,
    image: '/images/keyword/5.jpg',
    location: 'Pune To Mumbai Airport Taxi',
    title: 'Travel with ease and comfort with Mauli Cabs. Our Pune to Mumbai Airport Taxi service offers reliable, on-time transfers with professional drivers and clean vehicles—ideal for stress-free airport travel.',
    link: '/Pune-to-Mumbai-Airport-Taxi',
    duration: '6 - Days',
    oldPrice: '$800',
    newPrice: '$8000',
  },
  {
    id: 4,
    image: '/images/keyword/9.jpg',
    location: 'Pune To Pandharpur Cab Booking',
    title: 'Embark on a serene journey with Mauli Cabs. Our Pune to Pandharpur Cab Service offers a comfortable and hassle-free ride, ensuring you experience the spiritual essence of Pandharpur with ease.',
    link: '/Pune-to-Pandharpur-Cab-Booking',
    duration: '6 - Days',
    oldPrice: '$800',
    newPrice: '$700',
  },
  {
    id: 5,
    image: '/images/keyword/11.jpg',
    location: 'Pune To Ashtavinayak Darshan Cab',
    title: 'Embark on a divine journey with Mauli Cabs. Our Pune to Ashtavinayak Darshan Cab service offers a comfortable and hassle-free ride, ensuring you visit all eight revered Ganesh temples with ease and devotion.',
    link: '/Pune-to-Ashtavinayak-Darshan-Cab',
    duration: '3 - Days',
    oldPrice: '$800',
    newPrice: '$400',
  },
  {
    id: 6,
    image: '/images/keyword/55.jpg',
    location: 'Pune to Goa Cabs',
    title: 'Embark on a scenic journey with Mauli Cabs. Our Pune to Goa Cab Service offers a comfortable and hassle-free ride, ensuring you experience the coastal beauty and vibrant culture of Goa with ease.',
    link: '/Pune-to-Mumbai-Airport-Taxi',
    duration: '6 - Days',
    oldPrice: '$800',
    newPrice: '$8000',
  },
];

const Service = () => {

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Taxi Services - Mauli Cabs",
    "url": "https://www.maulicabs.com/services",  // Replace with actual URL
    "description": "Mauli Cabs offers reliable and professional taxi services for one-way and round trips between Mumbai and Pune. Choose from Innova Crysta, Ertiga, and sedan options for airport transfers, outstation travel, and more."
  };
  
 
  
  return (
    <>


<Helmet>
    <title> Services | Mauli Cabs | Mumbai to Pune Taxi, Airport Transfers & More</title>
    <meta
      name="description"
      content="View all taxi services provided by Mauli Cabs including Mumbai to Pune one-way and round trip cab bookings, airport transfers, outstation cabs, and custom travel packages."
    />
    <meta
      name="keywords"
      content="mauli cabs services, mumbai to pune cab service, airport taxi mumbai pune, outstation cab mumbai, mauli taxi options, one way cab mauli cabs, round trip cabs pune, mauli cab features, travel services mumbai, innova crysta cab mumbai"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
       

        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Services </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vs-tour-package style-2 space">
        <div className="container">
          <div className="row">
            <div className="col-lg-auto mx-auto">
              <div className="title-area text-center">
                
                
              </div>
            </div>
          </div>

          <div className="row g-4">
            {fleetPackages.map((item) => (
              <div className="col-md-6 col-xl-4" key={item.id}>
                <div className="tour-package-box style-3 bg-white-color">
                  <div className="tour-package-thumb">
                    <img src={item.image} alt="tour-package" className="w-100" />
                  </div>
                  <div className="tour-package-content">
                    <div className="location">
          
                      <span>{item.location}</span>
                    </div>
                    <h5 className="title line-clamp-2">
                      <a href={item.link}>{item.title}</a>
                    </h5>
                    <div className="tour-package-footer">
                      <div className="tour-duration">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                         
                        </svg>
                        {/* <span>{item.duration}</span> */}
                      </div>
                      {/* <div className="pricing-info fw-medium">
                        From <del className="text-theme-color fw-semibold">{item.oldPrice}</del>
                        <h5 className="new-price">{item.newPrice}</h5>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};

export default Service;
